import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TermsOfUse001 from '../../../../assets/LinkedFieldTermsOfUse001.png';
import TermsOfUse002 from '../../../../assets/LinkedFieldTermsOfUse002.png';
import TermsOfUse003 from '../../../../assets/LinkedFieldTermsOfUse003.png';
import TermsOfUse004 from '../../../../assets/LinkedFieldTermsOfUse004.png';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import {
  BACKGROUND_BLACK,
  BLACK,
  ORANGE,
} from '../../../../styles/Colors';

const useStyles = makeStyles(() => ({
  screenContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: BACKGROUND_BLACK,
    width: '100%',
  },
  rowContainer: {
    marginTop: HEADER_HIGHT,
    width: '100%',
    backgroundColor: ORANGE,
    textAlign: 'center',
  },
  rowText: {
    margin: '40px 0',
    color: BLACK,
    fontSize: 26,
    fontFamily: 'Volkhov',
  },
  imageContainer: {
    width: '80%',
  },
  image: {
    width: '100%',
    objectFit: 'contain',
  },
}));

const Term = () => {
  const classes = useStyles();

  return (
    <div className={classes.screenContainer}>
      <div className={classes.rowContainer}>
        <div className={classes.rowText}>
          Terms of Use
        </div>
      </div>
      <div className={classes.imageContainer}>
        <img
          alt="TermsOfUse001"
          src={TermsOfUse001}
          className={classes.image}
        />
        <img
          alt="TermsOfUse002"
          src={TermsOfUse002}
          className={classes.image}
        />
        <img
          alt="TermsOfUse003"
          src={TermsOfUse003}
          className={classes.image}
        />
        <img
          alt="TermsOfUse004"
          src={TermsOfUse004}
          className={classes.image}
        />
      </div>
    </div>
  );
};

export default Term;
